import { Box, Divider, Link, Tooltip } from "@mui/material";
import ScopeView from "../scope/scopeview";
import UserScopeTemplateView from "./userScopeTemplateView";
import { InfoOutlined, QuestionMark, QuestionMarkRounded } from "@mui/icons-material";
import { AuthGuard } from "../../../common/AuthGuard";
import { AppPermissions } from "../../../../constants/Permissions";
import { useNavigate } from "react-router";

interface UserScopeViewProps {
    userId: string;
}

const UserScopeView = (props: UserScopeViewProps) => {
    const navigate = useNavigate();

    return <>
        <Box padding={"0 0.5em 0 1.5em"}>
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                    <h3>Assigned Templates</h3>
                    <Tooltip style={{marginLeft: "0.5em"}} title="Apply one or more scope templates to allow users to inherit the predefined scopes. Any modifications made to a template will be seamlessly propagated to the users assigned to that specific template. This ensures consistency and efficiency in managing scopes across user groups.">
                        <InfoOutlined />
                    </Tooltip>
                </Box>
                <AuthGuard permission={AppPermissions.ScopeTemplate.Edit}>
                    <Tooltip title="The page will open in a new tab">
                        <Link sx={{display: "flex", marginRight: "1.5em"}} href="/scopetemplates" target="_blank">
                            Manage templates
                        </Link>
                    </Tooltip>
                </AuthGuard>
            </Box>
            <Box padding={"0 1.5em 0 1.5em"}>
                <UserScopeTemplateView userId={props.userId} />
            </Box>
        
            <Divider orientation="horizontal" style={{marginTop: "1em"}} />
        
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                <h3>User specific Scope</h3>
                <Tooltip style={{marginLeft: "0.5em"}} title={
                    <span>
                        Scopes not allocated via a predefined template (refer to the section above) can be individually assigned to users. 
                        It is advised to maximize the utilization of scope templates to ensure a consistent delineation of scopes across various user groups.
                        <br/><br />
                        Note that scope values assigned through a template cannot be unassigned manually.
                    </span>}>
                    <InfoOutlined />
                </Tooltip>
            </Box>
            <ScopeView isReadOnly={false} targetId={props.userId} targetType='user' />
        </Box>
    </>
}

export default UserScopeView;